import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS_WITH_SUBSCRIPTION_DATA = ['helpCenterClick', 'getHelpClick', 'timestampTimelineEdited'] as const;
const EVENTS_WITH_SUBSCRIPTION_DATA_AND_TTS = ['anyResultDownloaded'] as const;

const miscEventsWithSubscriptionData = getMappedEvents([...EVENTS_WITH_SUBSCRIPTION_DATA], {
  shouldSendSubscriptionData: true,
});

const miscEventsWithSubscriptionDataAndTTS = getMappedEvents([...EVENTS_WITH_SUBSCRIPTION_DATA_AND_TTS], {
  shouldSendRaskTTSData: true,
  shouldSendSubscriptionData: true,
});

export const miscEvents = [...miscEventsWithSubscriptionData, ...miscEventsWithSubscriptionDataAndTTS];
